<template>
    <div>

        <!-- <div class="display_msg pos_inherit" grey-back v-if="!listItemObject.totalCount">There are no activities!</div> -->

        <div>

            <v-list grey-back two-line nopadding v-if="listItemObject.totalCount">

                <div white-back v-for="(item, index) in listItemObject.items" :key="index" :class="{'mt-2':index!=0}" :id="'item_'+item.transactionId">
                    <v-list-item class="right-subtitle-tile" @click="fn_itemClick(item, index)">
                        <v-list-item-content>
                          <v-list-item-title class="mb-1">{{fn_transactionName(item.transactionListId)}}</v-list-item-title>
                          <v-list-item-subtitle>
                            <span v-if="item.mergeTransactionNumber" class="primary-color">{{item.mergeTransactionNumber}}</span>
                            {{item.mergeTransactionNumber ? ' | ' : ''}}
                            {{fn_transactionDate(item.transactionListId, item.transactionDate)}}
                          </v-list-item-subtitle>
                          <!-- <v-list-item-subtitle>{{item.transactionDate | moment("DD-MMM-YYYY")}}</v-list-item-subtitle> -->
                        </v-list-item-content>

                        <v-list-item-action font16 align-flex-end>
                            <div class="warning-label" v-if="!item.status">Cancelled</div>
                            <!-- <div v-else></div> -->
                            <div>&#8377; {{$root.numberToLocale(Math.abs(item.roundedAmount))}}</div>
                        </v-list-item-action>
                    </v-list-item>

                    <v-divider v-if="item.invoiceTemplate"></v-divider>
                    <div right-align style="padding:2px 6px;position:relative" v-if="item.invoiceTemplate">
                        <!-- <div class="warning-label" v-if="!item.status">Cancelled</div> -->
                        <v-btn nomargin icon text @click="fn_preview(item, true)"><v-icon font20>print</v-icon></v-btn>
                        <v-btn nomargin icon text @click="fn_preview(item)">
                            <v-icon>preview</v-icon>
                        </v-btn>
                    </div>

                    <!-- <v-divider v-if="listItemObject.items.length-1 != index"></v-divider> -->
                </div>


            </v-list>

            <!-- <v-row class="fill-height" align-content="center" justify="center" style="position:absolute;top:0;bottom:0;width: calc(100% - 280px);z-index:99" v-if="loadMore">
              <v-col cols="6">
                <v-progress-linear rounded indeterminate :height="6" color="primary"></v-progress-linear>
              </v-col>
            </v-row> -->

            <!-- <transition name="fade" mode="out-in">
                <v-card noshadow v-if="showPlaceHolder && !listItemObject.totalCount" style="height: calc(100vh - 366px);display: flex;align-items: center;">
                    <v-card-text>

                        <div center-align>
                            <div @click="openDialogOptions" v-ripple style="width: 68px;height: 68px;border-radius: 50%;background: #F0F0F0;margin: auto;padding: 12px;position:relative">
                                <i aria-hidden="true" class="v-icon material-icons" style="position: absolute;top: 0;right: 0px;background: #4b77be !important;border-radius: 50%;color: #fff !important;font-size: 20px;">add</i>
                                <img src="../../../../../assets/icon_wallet.svg" style="opacity:0.6;width:42px" alt="">
                            </div><br>

                            <p class="title light-opacity-color" style="line-height:28px !important">Add your first Transaction for {{partyName}}</p>
                        </div>

                    </v-card-text>
                </v-card>
            </transition> -->


            <div style="display: flex;justify-content: center;padding: 16px;background: #f0f0f0;" v-if="loadMore">
                <!-- <v-progress-circular indeterminate color="primary" v-if="loadMore"></v-progress-circular> -->
                <v-progress-linear rounded indeterminate :height="6" color="primary" style="width:120px;"></v-progress-linear>
            </div>
        </div>

    </div>
</template>

<script>

const transactionForms = require('../../../../../config.js').configs.transactionForms;

import {transactionMixin} from '../../../../transactions/transaction_mixin'

    export default{
        mixins: [transactionMixin],
        props:['partyId', 'partyName', 'groupTypeId', 'preview', 'bindInvoiceTemplate', 'openDialogOptions'],
        data(){
            return{
                toolbarTitle:null,
                listItemObject:{"items":[], "totalCount":0},
                searchValue:'',
                infiniteId: +new Date(),
                startIndex:0,
                scrollPositionTop:0,
                selectedItemId:null,
                loadMore: false,
                showPlaceHolder:false
            }
        },
        methods:{

            fn_preview: function(item, isPrint){
                item.toolbarTitle = this.fn_transactionName(item.transactionListId);
                let printType = item.invoiceTemplate == 101 ? 'ab' : item.invoiceTemplate == 201 ? 'sj' : null;

                let type = null;
                if(item.transactionListId == 10001 || item.transactionListId == 10002 || item.transactionListId == 10003 || item.transactionListId == 10004 || item.transactionListId == 10005){
                  type = 'sale';
                }
                else if(item.transactionListId == 20001 || item.transactionListId == 20002 || item.transactionListId == 20003 || item.transactionListId == 20004){
                  type = 'purchase';
                }
                else if(item.transactionListId == 20005){
                  type = 'expense';
                }
                // else if(item.transactionListId == 40002){
                //   type = 'inventory';
                // }
                
                this.fn_previewInvoice(true, type, printType, item, isPrint);
            },

            fn_transactionDate: function(listId, transactionDate){
                if(listId != 40003){
                    return this.$moment(transactionDate).format('DD-MMM-YYYY'); 
                }
                else{
                    return this.$moment(this.$root.CurrentBusiness.OpeningDate).format('DD-MMM-YYYY');      
                    // let od = new Date(transactionDate);
           //          od.setDate(od.getDate()+1);
                    // let tDate = new Date(od);
                    // return this.$moment(tDate).format('DD-MMM-YYYY');
                }
            },

            // onScroll: function(event){
            //     var element = event.target;
            //     if (element.scrollHeight - element.scrollTop - 20 <= element.clientHeight)
            //     {
            //         console.log('scrolled');
            //         if(this.listItemObject.items.length < this.listItemObject.totalCount){
            //             this.fn_loadItems();
            //         }
            //     }
            // },

            fn_transactionName: function(transactionListId){
                for(let i=0; i<transactionForms.length; i++){
                    if(transactionForms[i].id == transactionListId){
                        return transactionForms[i].title;
                    }
                }
            },

            fn_menuItemClick: function(tagId, menuId, menuAction){
                if(menuAction=='edit'){
                    this.$router.push('/transactions/sales/saleinvoice/items/'+this.selectedItemId+'/edit');
                }
            },

            fn_itemClick: function (item, index) {
                let obj = {};
                obj.itemId = null;
                obj.lastScrollPos = window.pageYOffset;
                obj.itemIndex = index + 1;
                localStorage.setItem("transaction_items_state", JSON.stringify(obj));

                let viewName = this.fn_transactionName(item.transactionListId);

                // this.$root.fn_navigateToDisplayView(item.transactionListId, item.transactionId);
                this.$router.push({path:'/'+this.$root.CurrentBusiness.BusinessID+'/'+this.$route.params.listId+'/'+viewName.toLowerCase().replace(/ /g,'')+'/items/'+item.transactionId, query:{back:1}});
                // this.$router.push('/transactions/sales/saleinvoice/items/'+itemId);
            },

            // fn_getBottomMenu: function (elementId, itemId) {
            //     itemId ? this.selectedItemId = itemId : '';

            //     let bottomMenu;

            //     if(elementId == bottomSheetMenu.toolBar.Id){
            //         bottomMenu = {"BottomMenu": []};
            //     }
            //     else if(elementId == bottomSheetMenu.masterListItems.Id){
            //         bottomMenu = {"BottomMenu": [menuItem.edit]};
            //     }
                
            //     this.setBottomMenu(tagId, bottomMenu, 
            //         {
            //             onSuccess: function (response) {
            //                 console.log(response);
            //             },
            //             onError: function (error) {
            //                 console.log(error);
            //             }
            //         }
            //     )
            // },

            fn_loadItems: function(isFirstLoad) {
                if(isFirstLoad){
                    this.listItemObject = {"items":[], "totalCount":0};
                }

                this.loadMore = true;
                let filterObject = {};
                filterObject.partyId = this.partyId;
                filterObject.limit = 50;
                filterObject.startIndex = this.startIndex;
                filterObject.search = this.searchValue.toLowerCase();
                filterObject.groupTypeId = this.groupTypeId;
                this.loading = true;

                let pageState = null;
                if(localStorage.getItem("transaction_items_state")){
                    pageState = JSON.parse(localStorage.getItem("transaction_items_state"));
                    filterObject.limit = 50 - (pageState.itemIndex % 50) + pageState.itemIndex;
                }

                let self = this;
                this.getItems("LedgerActivities", filterObject, 
                    {
                        onSuccess: function (response) {
                            console.log(response);
                            let responseJson = JSON.parse(response);
                            self.listItemObject.totalCount = responseJson.totalCount;

                            for(let i in responseJson.items){
                                let itemIndex = self.listItemObject.items.findIndex(item => item.transactionId==responseJson.items[i].transactionId);

                                if(itemIndex==-1){
                                    self.listItemObject.items.push(responseJson.items[i]);  
                                }
                                // self.listItemObject.items.push(responseJson.items[i]);   
                            }

                            console.log(pageState);
                            // if(pageState && pageState.itemId){
                            //  setTimeout(function(){
                            //      let scrollOptions = {"duration":0, "offset":0, "easing":"linear"};
                            //      self.$vuetify.goTo('#item_'+pageState.itemId, scrollOptions);
                            //      localStorage.removeItem("transaction_items_state");
                            //  },100);
                            // }

                            if(pageState && !pageState.itemId){
                                setTimeout(function(){
                                    let scrollOptions = {"duration":0, "offset":0, "easing":"linear"};
                                    self.$vuetify.goTo(pageState.lastScrollPos, scrollOptions);
                                    localStorage.removeItem("transaction_items_state");
                                },100);
                            }

                            if(localStorage.getItem("scroll_top")){
                                setTimeout(function(){
                                    let scrollOptions = {"duration":0, "offset":0, "easing":"linear"};
                                    self.$vuetify.goTo(0, scrollOptions);
                                },100);
                            }

                            // if(!pageState){
                            //  setTimeout(function(){
                            //      let scrollOptions = {"duration":300, "offset":0, "easing":"linear"};
                            //      self.$vuetify.goTo(0, scrollOptions);
                            //  },100);
                            // }

                            self.startIndex = self.listItemObject.items.length;
                            self.loadMore = false;

                            setTimeout(function(){
                                self.showPlaceHolder = true;
                            },300);
                        },
                        onError: function (error) {
                            console.log(error);
                            self.loadMore = false;
                        }
                    }
                )
            }


        },
        // mounted: function(){
        //     this.fn_loadItems();
        // }
    }
</script>